module.exports = __webpack_public_path__ + "assets/e32839478e2f1ff4d4e6bed7d26c00a0.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/drop/0/WildStop4.mp3
 ** module id = 244
 ** module chunks = 0
 **/